import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeSubscribable } from 'src/app/core/rxjs/extensions';
import { EditCourseModuleDialogData, EditCourseModuleDialogForm } from './edit-course-module-dialog.viewmodel';

@Component({
  selector: 'app-edit-course-module-dialog',
  templateUrl: './edit-course-module-dialog.component.html',
  styleUrls: ['./edit-course-module-dialog.component.css']
})
export class EditCourseModuleDialogComponent implements OnInit, OnDestroy, SafeSubscribable, EditCourseModuleDialogForm {
  form!: FormGroup;
  title: string;

  moduleTitle?: string;

  changed = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditCourseModuleDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: EditCourseModuleDialogData) {
      // Dynamic title for Add or Edit Module
      this.title = data.title;

      this.moduleTitle = data.moduleTitle;
    }

  ngOnInit() {
    this.form = this.fb.group({
      moduleTitle: [this.moduleTitle, []],
    });

    this.form.valueChanges.safeSubscribe(this, value => {
      this.changed = true;
    });
  }

  ngOnDestroy() {}

  save() {
    if (this.changed) {
      this.dialogRef.close(this.form.value);
    }
    else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }
}
